import I18n from 'I18n';
import { Component } from 'react';
import memoize from 'transmute/memoize';
import TimezoneTypes from 'I18n/constants/TimezoneTypes';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UITooltipContent from 'UIComponents/tooltip/UITooltipContent';
import Small from 'UIComponents/elements/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TOOLTIP_DATETIME_FORMAT = 'll LTS z';
const TOOLTIP_DATETIME_FORMAT_NO_SECONDS = 'll LT z';
const getTooltipContent = memoize((value, hideSeconds, tooltipType) => {
  const tooltipFormat = hideSeconds ? TOOLTIP_DATETIME_FORMAT_NO_SECONDS : TOOLTIP_DATETIME_FORMAT;
  const portalTz = I18n.moment[TimezoneTypes.PORTAL](value).format(tooltipFormat);
  const userTz = I18n.moment[tooltipType](value).format(tooltipFormat);
  if (tooltipType === TimezoneTypes.USER_OBJECT) {
    return /*#__PURE__*/_jsxs(UITooltipContent, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-i18n.formattedDateTimeWithZones.user"
      }), ": ", userTz, /*#__PURE__*/_jsx("br", {}), portalTz === userTz ? /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-i18n.formattedDateTimeWithZones.timezoneMatchUser"
        })
      }) : /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-i18n.formattedDateTimeWithZones.portal"
        }), ": ", portalTz]
      })]
    });
  }
  return /*#__PURE__*/_jsxs(UITooltipContent, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-i18n.formattedDateTimeWithZones.local"
    }), ": ", userTz, /*#__PURE__*/_jsx("br", {}), portalTz === userTz ? /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-i18n.formattedDateTimeWithZones.timezoneMatch"
      })
    }) : /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-i18n.formattedDateTimeWithZones.portal"
      }), ": ", portalTz]
    })]
  });
});
class FormattedDateTimeWithZones extends Component {
  constructor(props) {
    super(props);
    this.renderTooltipContent = this.renderTooltipContent.bind(this);
  }
  renderTooltipContent() {
    const {
      value,
      hideSeconds = false,
      tooltipType = TimezoneTypes.USER
    } = this.props;
    return getTooltipContent(value.valueOf(), hideSeconds, tooltipType);
  }
  render() {
    const {
      hideTooltip = false,
      useMultiline = false,
      placement,
      format,
      type = TimezoneTypes.PORTAL,
      value
    } = this.props;
    const timestamp = value.valueOf();
    let spanContent = I18n.moment[type](timestamp).format(format);
    if (useMultiline) {
      const dateContent = I18n.moment[type](timestamp).format('ll');
      const timeContent = I18n.moment[type](timestamp).format('LT z');
      spanContent = /*#__PURE__*/_jsxs(_Fragment, {
        children: [dateContent, /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Small, {
          children: timeContent
        })]
      });
    }
    return /*#__PURE__*/_jsx(UITooltip, {
      maxWidth: 300,
      disabled: hideTooltip,
      placement: placement,
      Content: this.renderTooltipContent,
      children: /*#__PURE__*/_jsx("span", {
        children: spanContent
      })
    });
  }
}
export default FormattedDateTimeWithZones;